import { render } from "./ManagerVacationRequests.vue?vue&type=template&id=d96b5e5c&scoped=true"
import script from "./ManagerVacationRequests.vue?vue&type=script&lang=js"
export * from "./ManagerVacationRequests.vue?vue&type=script&lang=js"

import "./ManagerVacationRequests.vue?vue&type=style&index=0&id=d96b5e5c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d96b5e5c"]])

export default __exports__